import { render, staticRenderFns } from "./becomeauthor.vue?vue&type=template&id=ec3f91c0&"
import script from "./becomeauthor.vue?vue&type=script&lang=js&"
export * from "./becomeauthor.vue?vue&type=script&lang=js&"
import style0 from "./becomeauthor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports